<template>
  <el-dialog
    title="批量发票上传"
    width="600px"
    @close="hideDialog('reconcileBill/mu_isShowImportDialog')"
    :visible="isShowImportDialog"
  >
    <el-upload
      ref="uploadExcel"
      :limit="1"
      accept=".xls, .xlsx"
      :auto-upload="false"
      action=""
      :loading="isLoading"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
    >
      <el-button size="small" type="primary">点击选择文件</el-button>
      <div slot="tip" class="el-upload__tip">
        注：每次只能导入一个.xls或者.xlsx文件，且不超过20MB
      </div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save" :loading="isLoading" :disabled="!fileList.length"
        >确定</el-button
      >
      <el-button @click="hideDialog('reconcileBill/mu_isShowImportDialog')">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { dialogCtrl } from '@/mixins'
// import { computeAdd } from '@/utils'

export default {
  name: 'importDialog',
  components: {},
  mixins: [dialogCtrl],
  props: ['selectedRows', 'payOrderIds'],
  data() {
    return {
      fileList: [],
      isLoading: false
    }
  },
  computed: {
    ...mapState('reconcileBill' ,['isShowImportDialog'])
  },
  created() {},
  mounted() {
    this.$debugVue('v_budgetMgmt_importPlan', this)
  },
  watch: {},
  methods: {
    async save() {
      try {
        this.isLoading = true
        const file = this.fileList[0].raw
        const formData = new FormData()
        formData.append('file', file)
        formData.append('orderId', this.payOrderIds.join(','))
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        const res = await this.fetch.post('reconcileBill_multiInvoicesRecoding', formData, config)
        if (res) {
          this.isLoading = false
          this.$message.success(res.message)
          this.$emit('change')
          this.hideDialog('reconcileBill/mu_isShowImportDialog')
        }
      } catch (e) {
        this.isLoading = false
        this.$message.error(e.errMsg)
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件`
      )
    },
    handleChange(file, fileList) {
      const isOverSize = file.size > 20 * 1024 * 1024
      if (isOverSize) {
        this.$message.warning(`文件不超过20MB`)
        fileList.pop()
        return
      }
      this.fileList = [file]
    },
    handleRemove() {
      this.fileList = []
    }
  }
}
</script>

<style scoped lang="scss"></style>
